import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, Loader2, ImagePlus } from "lucide-react";

/** Grand aperçu de la façade (original, variante IA ou rendu personnalisé). */
export function ResultPreview({
  displayedImage,
  applyLoading,
  generated,
  selectedVariant,
  onOpenPicker,
}) {
  return (
    <motion.div
      id="configurator-result"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="relative aspect-[16/10] rounded-3xl overflow-hidden border border-white/10 bg-[#0a0a0a]"
      data-testid="configurator-preview"
    >
      <AnimatePresence mode="wait">
        <motion.img
          key={displayedImage}
          src={displayedImage}
          alt="Façade"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="absolute inset-0 w-full h-full object-cover"
          data-testid="configurator-preview-image"
        />
      </AnimatePresence>

      {applyLoading && (
        <div className="absolute inset-0 bg-black/75 backdrop-blur-sm flex flex-col items-center justify-center gap-4 z-10">
          <Loader2 size={48} className="animate-spin text-[#FF5A00]" />
          <div className="text-white font-display text-lg">
            Application des options…
          </div>
          <div className="text-neutral-400 text-sm">Patientez ≈ 30 secondes</div>
        </div>
      )}

      {generated && !applyLoading && (
        <div className="absolute top-4 left-4 bg-[#FF5A00] text-white text-xs uppercase tracking-wider px-3 py-1.5 rounded-full font-medium flex items-center gap-1.5">
          <Sparkles size={12} /> Rendu personnalisé
        </div>
      )}
      {!generated && !applyLoading && selectedVariant && (
        <div className="absolute top-4 left-4 bg-[#FF5A00] text-white text-xs uppercase tracking-wider px-3 py-1.5 rounded-full font-medium flex items-center gap-1.5">
          <Sparkles size={12} /> Style {selectedVariant}
        </div>
      )}

      <button
        type="button"
        onClick={onOpenPicker}
        className="absolute top-4 right-4 bg-black/70 backdrop-blur text-white text-xs uppercase tracking-wider px-3 py-1.5 rounded-full hover:bg-black transition-colors flex items-center gap-1.5"
        data-testid="configurator-change-photo"
      >
        <ImagePlus size={12} /> Changer
      </button>
    </motion.div>
  );
}
